// extracted by mini-css-extract-plugin
export var box = "_6e-1";
export var checked = "_6e-2";
export var descriptionSpacer = "_6e-9";
export var disabled = "_6e-3";
export var icon = "_6e-6";
export var input = "_6e-0";
export var labelSpacer = "_6e-8";
export var medium = "_6e-5";
export var small = "_6e-4";
export var text = "_6e-7";